import axios from "axios";
import { baseUrl } from "../util";

const getConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("access_token")}`,
    "Content-Type": "application/json",
  },
});

export const actionPlanFeedbackService = {
  getFeedback: async (effortId) => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/business/efforts/${effortId}/feedback/`,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error fetching feedback:", error);
      throw error;
    }
  },
  createFeedback: async (effortId, investmentData) => {
    try {
      const payload = {
        title: investmentData.title,
        description: investmentData.description,
      };

      const response = await axios.post(
        `${baseUrl}/api/business/efforts/${effortId}/feedback/`,
        payload,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error creating investment:", error);
      throw error;
    }
  },

  updateFeedback: async (effortId, followUpId, investmentData) => {
    try {
      const payload = {
        title: investmentData.title,
        description: investmentData.description,
      };

      const response = await axios.put(
        `${baseUrl}/api/business/efforts/${effortId}/feedback/${followUpId}/`,
        payload,
        getConfig()
      );
      return response.data.data;
    } catch (error) {
      console.error("Error updating investment:", error);
      throw error;
    }
  },

  deleteFeedback: async (effortId, followUpId) => {
    try {
      const response = await axios.delete(
        `${baseUrl}/api/business/efforts/${effortId}/feedback/${followUpId}/`,
        getConfig()
      );
      return response.status === 204;
    } catch (error) {
      console.error("Error deleting investment:", error);
      throw error;
    }
  },
};

export default actionPlanFeedbackService;
